/* import-sort-ignore */

/**
 * -----------------
 * Honeycomb modules
 * -----------------
 */

// Pingdom.
import pingdom from 'honeycomb-web-toolkit/src/analytics/js/honeycomb.analytics.pingdom';
pingdom.init();

// Document.
import documentLocation from 'honeycomb-web-toolkit/src/document/js/honeycomb.document.location';

// Navigation
import dropdown from 'honeycomb-web-toolkit/src/navigation/js/honeycomb.navigation.dropdown';
dropdown.init();

import mobileMenu from 'honeycomb-web-toolkit/src/navigation/js/honeycomb.navigation.header';
mobileMenu.init();

// Notification
import notifications from 'honeycomb-web-toolkit/src/notification/js/honeycomb.notification.block';
notifications.init();

// SVG.
import svg from 'honeycomb-web-toolkit/src/svg/js/honeycomb.svg';
svg.init();

// Reveal.
import reveal from 'honeycomb-web-toolkit/src/reveal/js/honeycomb.reveal';
reveal.init();

// Lightbox.
import lightbox from 'honeycomb-web-toolkit/src/lightbox/js/honeycomb.lightbox';
lightbox.init({
    url: wpOptions.cdnUrl + "/assets/scripts/scripts/external/jquery.fancybox.pack.js"
});

// Marketo forms
import marketoForms from 'honeycomb-web-toolkit/src/forms/js/honeycomb.forms.marketo';
window.ST = window.ST || {};
window.ST.marketoForms = marketoForms;


// -------------------
// Simple-Talk modules
// -------------------

// Import the same cookie-consent module instance that honeycomb sub-modules use
// internally (e.g. analytics.google). Initialising it here with the correct cookie
// name means every honeycomb module in this bundle reads rgcookieconsent rather than
// the default hccookieconsent. Guarded by cookie existence so we don't insert a second
// banner on top of the one cookie-consent.js already shows for first-time visitors.
import cookieConsent from 'honeycomb-web-toolkit/src/cookie-consent/js/honeycomb.cookie-consent';
if (document.cookie.split(';').some(c => c.trim().startsWith('rgcookieconsent='))) {
    cookieConsent.init({
        consentGroups: ['performance', 'targeting'],
        cookie: { name: 'rgcookieconsent', domain: '.red-gate.com' },
    });
}

// Google analytics - Honeycomb
import googleAnalytics from 'honeycomb-web-toolkit/src/analytics/js/honeycomb.analytics.google';
if (cookieConsent.hasConsent('performance')) {
    googleAnalytics.setAccountId('G-NPWCY1Z5M6');
    googleAnalytics.setCrossDomainAccountId('G-X7VDRWRT4P');
    googleAnalytics.init();
}
window.ST = window.ST || {};
window.ST.analytics = googleAnalytics;

// Google Analytics - Simple Talk
import analytics from './simple-talk/analytics.google.js';
if (cookieConsent.hasConsent('performance')) {
    window.addEventListener( "load", () => {
        analytics.init({
            analytics: googleAnalytics
        });
    });
}

// Marketo — deferred to idle time so script injection doesn't land in a tracked task.
import marketo from './simple-talk/analytics.marketo.js';
if (cookieConsent.hasConsent('performance')) {
    window.addEventListener('load', () => {
        if ('requestIdleCallback' in window) {
            requestIdleCallback(() => { marketo.init(); }, { timeout: 3000 });
        } else {
            setTimeout(() => { marketo.init(); }, 0);
        }
    });
}

// Hotjar — deferred to idle time; Hotjar is known to cause long tasks if run eagerly.
import hotjar from './simple-talk/analytics.hotjar.js';
if (cookieConsent.hasConsent('performance')) {
    window.addEventListener('load', () => {
        if ('requestIdleCallback' in window) {
            requestIdleCallback(() => { hotjar.init(); }, { timeout: 3000 });
        } else {
            setTimeout(() => { hotjar.init(); }, 0);
        }
    });
}

// Bookmarks
import bookmarks from './simple-talk/bookmarks.js';
window.addEventListener( "load", () => {
    bookmarks.init(documentLocation);
});

// Google search
import googleSearch from './simple-talk/google-search.js';
window.addEventListener( "load", () => {
    googleSearch.init();
});

// Read tracker
import readTracker from './simple-talk/read.js';
window.addEventListener( "load", () => {
    readTracker.startTracking();
});

// Videos
import videos from './simple-talk/videos.js';
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => videos.init());
} else {
    videos.init();
}

// Navigation
import navigation from './simple-talk/navigation.js';
window.addEventListener( "load", () => {
    navigation.init();
});

// Header FAQ notification
import header from './simple-talk/header.js';
header.init();

// Table
import table from './simple-talk/table.js';
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => table.init());
} else {
    table.init();
}

// Print
import print from './simple-talk/print.js';
window.addEventListener( 'load', print.init );

// Skip to content
import skipToContent from './simple-talk/skip-to-content';
skipToContent.init();

// Sticky TOC on post page

import initiateToc from './simple-talk/post-toc.js';
initiateToc.init();

// Modals on podcast and post page

import initiateModals from './simple-talk/modals.js';
initiateModals.init();

// Dark mode toggle on post page

import darkmodeToggle from './simple-talk/dark-mode-toggle.js';
darkmodeToggle.init();

// Interactivity in the recent podcasts block on the homepage

import recentPodcastBlock from './simple-talk/recent-podcasts-block.js';
recentPodcastBlock.init();



/**
 * ----------------
 * External scripts
 * ----------------
 */

// Disqus loader — run in requestIdleCallback so getBoundingClientRect() forced reflow
// happens during idle time, not a tracked task that Lighthouse flags.
import disqusLoader from './external/disqusLoader.js';
window.addEventListener('load', () => {
    if ('requestIdleCallback' in window) {
        requestIdleCallback(() => { disqusLoader.init(); });
    } else {
        disqusLoader.init();
    }
});
